module.exports = __webpack_public_path__ + "img/video-banner.7b7af4e3.svg";